module.exports = __webpack_public_path__ + "static/media/heading.481bee7f.svg";